import React, { useState, useEffect } from "react";

import { useParams, useLocation } from "react-router-dom";

import Group from "../../ServicosAcolhimento/Visualizar/Group";

import MovimentacaoService from "../../../../main/services/MovimentacaoService";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { Step } from "./Step";
import { CustomButton } from "../../../components/CustomButton";
import { parse, isValid } from "date-fns";

import {
  Box,
  Grid,
  GridItem,
  SimpleGrid,
  Text,
  useDisclosure,
} from "@chakra-ui/react";

import { CadastrarMovimentacaoModal } from "./Cadastrar";
import {
  Permission,
  criancaFunc,
  vrCriancaFunc,
  servicoAcolhimentoFunc,
} from "../../../../helpers/Funcionalidades";
import SemRegistros from "../../../components/SemRegistros";
import { CustomSelectWField } from "../../../components/CustomSelectWField";
import { CustomDatepickerWField } from "../../../components/CustomDatepickerWField";
import { Form, Formik } from "formik";
import MovimentoService from "../../../../main/services/MovimentoService";
import Swal from "sweetalert2";
import { differenceInYears } from "date-fns";
import { useAppContext } from "../../../../Context/MessageContextProvider";
import { useAuthProvider } from "../../../../Context/AuthProvider";

export const VisualizarMovimentacao = ({
  setLoadingPainel,
  dataNascimento,
}) => {
  const { id } = useParams();
  const { roleKeycloack, user } = useAuthProvider();
  const [data, setData] = useState();
  const [dataGeral, setDataGeral] = useState();
  const [intercalada, setIntercalada] = useState(false);
  const [loadingHistorico, setLoadingHistorico] = useState(false);
  const [loadingCadastro, setLoadingCadastro] = useState(false);
  const { setUltimaMovimentacaoBuscar, idPJ } = useAppContext();
  const {
    isOpen: isOpenCadastrar,
    onOpen: onOpenCadastrar,
    onClose: onCloseCadastrar,
  } = useDisclosure();
  const [loadingMovimentacoes, setLoadingMovimentacoes] = useState(false);
  const [motivos, setMotivos] = useState({ options: [], isLoading: false });

  const [movimentos, setMovimentos] = useState({
    options: [],
    isLoading: false,
  });
  const [validDataSearch1, setValidDataSearch1] = useState(true);
  const [validDataSearch2, setValidDataSearch2] = useState(true);
  const [initialValues, setInitialValues] = useState({
    situacaoSearch: "",
    movimentoSearch: "",
    motivoSearch: "",
    dataSearch1: "",
    dataSearch2: "",
  });

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const idAnexo = searchParams.get("idAnexo");
  const idAba = searchParams.get("idAba");

  const isOver18 = (birthdate) => {
    const age = differenceInYears(new Date(), new Date(parseInt(birthdate)));
    return age >= 18;
  };

  const determineOptions = () => {
    const options = [
      { label: "Acolhido", id: 1 },
      { label: "Desligado", id: 2 },
    ];

    if (isOver18(dataNascimento)) {
      options.push({ label: "Pendente", id: 3 });
    }

    return options;
  };

  const isValidDate = (value) => {
    if (!!value) {
      if (value.length === 10) {
        const parsedDate = parse(value, "dd/MM/yyyy", new Date());
        if (!isValid(parsedDate)) {
          return false;
        }
      } else {
        return false;
      }
    }
    return true;
  };

  const handleGetMovimentos = (dataGeral) => {
    setMovimentos({ ...movimentos, isLoading: true });

    MovimentoService.getMovimento()
      .then((res) => {
        const idsSituacao = dataGeral.map((item) =>
          item?.movimento?.id ? item?.movimento?.id : 3
        );

        const movimentosFiltrados = res.data.filter((movimento) =>
          idsSituacao.includes(movimento.id)
        );

        setMovimentos({
          options: movimentosFiltrados ? movimentosFiltrados : [],
          isLoading: false,
        });
      })
      .catch(() => console.log("Erro no get de movimentos"));
  };

  function parseDate(dateString) {
    const [day, month, year] = dateString.split("/");
    const parsedDate = new Date(`${year}-${month}-${day}`);

    const utcDate = new Date(
      parsedDate.getTime() + parsedDate.getTimezoneOffset() * 60000
    );
    return utcDate;
  }

  useEffect(() => {
    setLoadingMovimentacoes(true);

    const isDateValid =
      isValidDate(initialValues.dataSearch1) &&
      isValidDate(initialValues.dataSearch2);

    setValidDataSearch1(isValidDate(initialValues.dataSearch1), "dataSearch1");
    setValidDataSearch2(isValidDate(initialValues.dataSearch2), "dataSearch2");
    if (!isDateValid) {
      setLoadingMovimentacoes(false);
      return;
    }
    MovimentacaoService.getMovimentacoes(id)
      .then((res) => {
        const rawData = res.data;

        const filteredData = rawData.filter((movimentacao) => {
          const isTipoMatch =
            !initialValues.situacaoSearch ||
            (movimentacao.motivoSituacao
              ? movimentacao?.motivoSituacao?.tipoSituacao?.id ===
                initialValues.situacaoSearch.id
              : movimentacao.movimento
              ? movimentacao?.movimento?.tipoSituacao?.id ===
                initialValues.situacaoSearch.id
              : initialValues.situacaoSearch.id === 3 &&
                !movimentacao.motivoSituacao &&
                movimentacao?.movimento?.tipoSituacao?.id === 3);

          const isMovimentoMatch =
            !initialValues.movimentoSearch ||
            (movimentacao.movimento
              ? movimentacao.movimento.id === initialValues.movimentoSearch.id
              : movimentacao.motivoSituacao?.tipoSituacao.id === 1 &&
                initialValues.movimentoSearch.id === 3);

          const isMotivoMatch =
            !initialValues.motivoSearch ||
            movimentacao?.motivoSituacao?.id ===
              initialValues?.motivoSearch?.id;

          const dataMovimentacao = new Date(movimentacao.dataMovimentacao);

          const dataSearch1 = initialValues.dataSearch1
            ? parseDate(initialValues.dataSearch1)
            : null;

          const dataSearch2 = initialValues.dataSearch2
            ? parseDate(initialValues.dataSearch2)
            : null;

          const isDateMatch =
            (!dataSearch1 || dataMovimentacao >= dataSearch1) &&
            (!dataSearch2 ||
              new Date(dataMovimentacao.toDateString()) <=
                new Date(dataSearch2.toDateString()));

          const motivoSituacaoAcolhidoSet = new Set();

          const motivoSituacaoAcolhido = rawData
            .filter((item) => item.motivoSituacao)
            .filter(
              (item) =>
                item.motivoSituacao.tipoSituacao.id ===
                initialValues.situacaoSearch?.id
            )
            .filter((item) => {
              const id = item.motivoSituacao.id;
              if (!motivoSituacaoAcolhidoSet.has(id)) {
                motivoSituacaoAcolhidoSet.add(id);
                return true;
              }
              return false;
            })
            .map((item) => item.motivoSituacao);

          setMotivos({ options: motivoSituacaoAcolhido, isLoading: false });

          return (
            isTipoMatch && isMovimentoMatch && isDateMatch && isMotivoMatch
          );
        });

        const sortedData = filteredData.sort((a, b) => {
          return b.ordem - a.ordem;
        });

        setData(sortedData);
        setUltimaMovimentacaoBuscar(sortedData[0].id);
        if (initialValues.situacaoSearch) {
          setDataGeral(sortedData);
        }

        setLoadingMovimentacoes(false);
      })
      .catch((error) => {
        setLoadingMovimentacoes(false);
        console.log("Erro no get de movimentacao");
      })
      .finally(() => {
        setLoadingCadastro(false);
      });
  }, [
    loadingHistorico,
    loadingCadastro,
    setUltimaMovimentacaoBuscar,
    initialValues.situacaoSearch,
    initialValues.dataSearch1,
    initialValues.dataSearch2,
    initialValues.movimentoSearch,
    initialValues.motivoSearch,
    id,
  ]);

  const handleClearFilters = (props) => {
    const hasFilters =
      props.values.situacaoSearch ||
      props.values.movimentoSearch ||
      props.values.motivoSearch ||
      props.values.dataSearch1 ||
      props.values.dataSearch2;
    if (hasFilters) {
      Swal.fire({
        title: "Atenção",
        text: "É necessário limpar os filtros de pesquisa antes de cadastrar.",
        icon: "warning",
        confirmButtonColor: "#169499",
        confirmButtonText: "Ok",
      }).then((result) => {
        if (result.isConfirmed) {
          onCloseCadastrar();
        }
      });
    } else {
      onOpenCadastrar();
    }
  };

  return roleKeycloack &&
    (roleKeycloack.includes(vrCriancaFunc.movimentoVisualizar) ||
      ((roleKeycloack?.includes(criancaFunc.visualizarTudoAcolhimento) ||
        roleKeycloack?.includes(criancaFunc.visualizarTudoTutelar)) &&
        user?.orgaoExterno?.includes(idPJ))) ? (
    data ? (
      <Group
        title="Histórico de Movimentação"
        border={
          ["6", "7", "38", "39", "40"].includes(idAnexo) ||
          ["5"].includes(idAba)
            ? "3px solid #4299E199"
            : ""
        }
        position="relative"
      >
        <Formik initialValues={initialValues}>
          {(props) => (
            <>
              <SimpleGrid
                mt="30px"
                columns={{ base: 2, lg: 4 }}
                spacing="20px"
                marginTop={{ base: "10px", lg: "-50px" }}
                dir={"rtl"}
              >
                {roleKeycloack.includes(
                  servicoAcolhimentoFunc?.visualizarParteConsulente
                ) ||
                  (roleKeycloack.includes(
                    servicoAcolhimentoFunc?.visualizarPartePPCAAM
                  ) && (
                    <>
                      <Box h={"42px"} w={"auto"} />
                      <Box h={"42px"} w={"auto"} />
                    </>
                  ))}

                <Permission
                  roleKeycloack={roleKeycloack}
                  func={vrCriancaFunc.movimentoIntercalado}
                >
                  <CustomButton
                    width={"100%"}
                    label="Movimento Intercalado"
                    isDisabled={loadingMovimentacoes}
                    onClick={() => {
                      setIntercalada(true);
                      handleClearFilters(props);
                    }}
                  />
                </Permission>
                <Permission
                  roleKeycloack={roleKeycloack}
                  func={criancaFunc.desligar}
                >
                  <CustomButton
                    width={"100%"}
                    label="Cadastrar"
                    isDisabled={loadingMovimentacoes}
                    onClick={() => {
                      setIntercalada(false);
                      handleClearFilters(props);
                    }}
                  />
                </Permission>
              </SimpleGrid>
              <Box h={"42px"} w={"auto"} />
              <SimpleGrid
                mt="30px"
                columns={{ base: 1, sm: 2, lg: 5 }}
                spacing="20px"
                marginTop={"-50px"}
                dir="rtl"
              >
                <CadastrarMovimentacaoModal
                  isOpen={isOpenCadastrar}
                  onOpen={onOpenCadastrar}
                  data={data}
                  setLoadingCadastro={setLoadingCadastro}
                  setLoadingPainel={setLoadingPainel}
                  setLoadingHistorico={setLoadingHistorico}
                  roleKeycloack={roleKeycloack}
                  idCrianca={id}
                  intercalada={intercalada}
                  dataNascimento={dataNascimento}
                  onClose={() => {
                    onCloseCadastrar();
                  }}
                  user={user}
                  idPJ={idPJ}
                />
              </SimpleGrid>

              <Form>
                {setInitialValues(props.values)}
                <Grid
                  templateColumns="repeat(4, 1fr) 1fr"
                  mt={4}
                  columnGap={12}
                  rowGap={4}
                  mb={4}
                >
                  <GridItem colSpan={{ base: 5, lg: 2 }}>
                    <CustomSelectWField
                      fieldName="situacaoSearch"
                      placeholder="Pesquise por Situação"
                      getOptionLabel={(option) => option.label}
                      getOptionValue={(option) => option.id}
                      options={determineOptions()}
                      onChange={(value) => {
                        props.setFieldValue(
                          "situacaoSearch",
                          value ? value : ""
                        );
                        props.setFieldValue("motivoSearch", "");
                        props.setFieldValue("movimentoSearch", "");
                      }}
                    />
                  </GridItem>
                  <GridItem
                    colSpan={{ base: 5, lg: 3 }}
                    display={"flex"}
                    gap={6}
                    alignItems={"center"}
                  >
                    <Box position="relative" w={{ m: "0" }}>
                      <CustomDatepickerWField
                        fieldName="dataSearch1"
                        placeholder="DD/MM/AAAA"
                      />
                      {!validDataSearch1 && (
                        <Text
                          position="absolute"
                          color="red"
                          opacity={0.8}
                          fontSize="12px"
                        >
                          Data inválida!
                        </Text>
                      )}
                    </Box>

                    <Text>até</Text>

                    <Box position="relative" w={{ m: 0 }}>
                      <CustomDatepickerWField
                        fieldName="dataSearch2"
                        placeholder="DD/MM/AAAA"
                      />
                      {!validDataSearch2 && (
                        <Text
                          position="absolute"
                          color="red"
                          opacity={0.8}
                          mt={2}
                          fontSize="12px"
                        >
                          Data inválida!
                        </Text>
                      )}
                    </Box>
                  </GridItem>
                  <GridItem colSpan={{ base: 5, lg: 2 }}>
                    <CustomSelectWField
                      fieldName="movimentoSearch"
                      placeholder="Pesquise por Movimento"
                      getOptionLabel={(option) => option.descricao}
                      getOptionValue={(option) => option.id}
                      isDisabled={
                        props.values.situacaoSearch === "" || data.length <= 0
                      }
                      options={movimentos.options}
                      isLoading={movimentos.isLoading}
                      onFocus={() => handleGetMovimentos(dataGeral)}
                      onChange={(value) => {
                        props.setFieldValue(
                          "movimentoSearch",
                          value ? value : ""
                        );
                        props.setFieldValue("motivoSearch", "");
                      }}
                    />
                  </GridItem>

                  <GridItem colSpan={{ base: 5, lg: 2 }}>
                    <CustomSelectWField
                      fieldName="motivoSearch"
                      placeholder="Pesquise por Motivo"
                      getOptionLabel={(option) => option.descricao}
                      getOptionValue={(option) => option.id}
                      isDisabled={
                        props.values.movimentoSearch === "" ||
                        (props.values.movimentoSearch.id &&
                          (props.values.movimentoSearch.id === 1 ||
                            props.values.movimentoSearch.id === 2 ||
                            props.values.movimentoSearch.id === 6))
                      }
                      isLoading={motivos.isLoading}
                      options={motivos.options}
                      onChange={(value) => {
                        props.setFieldValue("motivoSearch", value ? value : "");
                      }}
                    />
                  </GridItem>
                </Grid>
              </Form>
            </>
          )}
        </Formik>
        {!loadingMovimentacoes ? (
          data && data.length > 0 ? (
            data.map((movimentacao, index) => (
              <Step
                key={index}
                step={data.length - index}
                movimentacao={movimentacao}
                idCrianca={id}
                data={data}
                movimentacaoAnterior={index}
                isLast={index === data.length - 1}
                isFirst={index === 0}
                onOpenCadastrar={onOpenCadastrar}
                setIntercalada={setIntercalada}
                setLoadingHistorico={setLoadingHistorico}
                setLoadingPainel={setLoadingPainel}
                setLoadingCadastro={setLoadingCadastro}
              />
            ))
          ) : (
            <Box mt="4">
              <SemRegistros buttonVisible={true} half />
            </Box>
          )
        ) : (
          <Box mt="4">
            <LoadingSpinner loading={true} />
          </Box>
        )}
      </Group>
    ) : (
      <LoadingSpinner loading={true} />
    )
  ) : (
    <Box mt={4}>
      <SemRegistros buttonVisible={true} half />
    </Box>
  );
};
